export const LOGIN = "LOGIN";
export const REFRESH_USER = "REFRESH_USER";
export const LOGOUT = "LOGOUT";
